import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import MenuList from "@/components/menu/MenuList.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Home',
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_card_text = _resolveComponent("v-card-text");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_container = _resolveComponent("v-container");
            return (_openBlock(), _createBlock(_component_v_container, { class: "home" }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_row, { justify: "center" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                                cols: "12",
                                md: "8"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card, { class: "pa-4" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_card_title, null, {
                                                default: _withCtx(() => _cache[0] || (_cache[0] = [
                                                    _createTextVNode("Wedding Me Works Support App")
                                                ])),
                                                _: 1,
                                                __: [0]
                                            }),
                                            _createVNode(_component_v_card_text),
                                            _createVNode(MenuList)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
